import type {PageThemeTemplateKey} from "sponsor/sponsorOptions";

/**
 * A look handed to the composer from OUTSIDE it (kitecorp/transferify-ui#3776): the landing's Halloween slide,
 * pressed, and a `?tema=` arrival put the slide's scene on the composer's draft. That draft lives in another tree
 * (`CreateFlow`'s `usePersonalizationDraft`, under the campaign surface that owns the slide), so it is reached
 * through this notice board rather than through props threaded across the page. React-free, the shape of
 * `pricing/welcomeRefusal`.
 *
 * One request is HELD until a composer takes it, so a press that lands before the composer listens is not lost,
 * and the composer that subscribes next takes it at once. Each request is delivered once: to every composer
 * listening when it is made, or else to the first one that starts listening; a newer request made while nobody
 * listens replaces the held one, because it is the slide the visitor pressed last.
 */
type Listener = (template: PageThemeTemplateKey) => void;
const listeners = new Set<Listener>();
let pending: PageThemeTemplateKey | null = null;

export function requestComposerTheme(template: PageThemeTemplateKey): void {
	if (listeners.size === 0) {
		pending = template;
		return;
	}
	pending = null;
	for (const listener of listeners) listener(template);
}

export function subscribeComposerTheme(listener: Listener): () => void {
	listeners.add(listener);
	if (pending !== null) {
		const held = pending;
		pending = null;
		listener(held);
	}
	return () => { listeners.delete(listener); };
}
